import React from 'react';
import { Segment, Button } from 'semantic-ui-react';
import StoresTableContainer from './StoresTableContainer';


const StoreTable = () => {
	let tableRef = React.useRef(null);
	return (
		<div className="animated fadetwoIn padded-top dnp-page">
			<Segment.Group stacked>
				<Segment color='green' className="tableHeaderContainer">
					<div />
					<h2>Store Management</h2>
					<Button
						onClick={() => {
							if(tableRef && tableRef.current) {
								tableRef.current.refresh();
							}
						}}
						content={<i className="fa fa-refresh fa-lg filterIcon" aria-hidden="true" />}
					/>
				</Segment>
				<Segment placeholder>
					<StoresTableContainer
						ref={tableRef}
						path="/admin/stores"
					/>
				</Segment>
			</Segment.Group>
		</div>
	);
};

export default StoreTable;